var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useState, } from 'react';
import { useFocusRing } from '@react-aria/focus';
import { mergeProps } from '@react-aria/utils';
import styled from 'styled-components';
import { margin } from '../../utils/margin';
import { CircularLoader } from '../Loader/CircularLoader';
import { SuperEllipse } from '../SuperEllipse/SuperEllipse';
import { sizesMapping } from '../SuperEllipse/SuperEllipseIcon';
const variantMapping = {
    primary: 'interactive.primary',
    secondary: 'interactive.secondary',
    text: 'interactive.text',
    critical: 'interactive.critical',
    contrast: 'interactive.contrast',
};
const StyledIconButton = styled.button `
  background: none;
  padding: 0;
  border: none;
  cursor: pointer;
  display: inline-block;

  &:focus {
    outline: none;
  }

  &.disabled {
    cursor: default;
    pointer-events: none;
  }

  ${margin}
`;
const IconButtonComponent = (_a, ref) => {
    var { component, variant = 'primary', size, name, disabled, loading, badge } = _a, props = __rest(_a, ["component", "variant", "size", "name", "disabled", "loading", "badge"]);
    const [isHovered, setIsHovered] = useState(false);
    const { isFocusVisible, focusProps } = useFocusRing();
    const loaderSize = sizesMapping[size];
    const isDisabled = disabled || loading;
    return (_jsx(StyledIconButton, Object.assign({ className: isDisabled ? 'disabled' : '', disabled: isDisabled, onMouseEnter: () => setIsHovered(true), onMouseLeave: () => setIsHovered(false), type: "button" }, mergeProps(focusProps, props), { ref: ref, as: component, children: _jsx(SuperEllipse, Object.assign({ size: size }, (!loading ? { icon: name } : {}), { colorSet: (isDisabled
                ? `${variantMapping[variant]}.disabled`
                : isHovered
                    ? `${variantMapping[variant]}.hover`
                    : variantMapping[variant]), highlight: isFocusVisible, badge: badge, children: loading && (_jsx(CircularLoader, { size: loaderSize, colorSet: "interactive.secondary.disabled" })) })) })));
};
export const IconButton = forwardRef(IconButtonComponent);
